<template>
  <v-layout>
    <filtersMaster
      ref="filtersMaster"
      :select="select"
      :filtersdef="filtros"
      :options="options"
      @filter="filter"
      @loadSelectsData="loadSelectsData"
      @loadSelectProvincia="loadSelectProvincia"
      @loadSelectLocalidad="loadSelectLocalidad" />
  </v-layout>
</template>
<script>
import FiltersMaster from "@/components/datatable/Filters"; /** *******************************/
import tippy from "tippy.js";
import CombosAPI from "@/services/catalogos";
import { SE_NEGOCIO_SELECT } from "@/constants/operativos";

export default {
  name: "FiltersModule"
  , components: { FiltersMaster }
  , data() {
    return {
      init: true
      , view: { action: { submit: { busy: false } } }
      , select: {
        negocio: {
          completeList: SE_NEGOCIO_SELECT
          , filteredList: SE_NEGOCIO_SELECT
          , disabled: false
        }
        , provincia: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , localidad: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , acuerdo: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , subindustria: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , partner: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
      }
      , filtros: {
        se: []
        , seller: []
        , storeid: []
        , negocio: []
        , cuit: []
        , provincia: []
        , localidad: []
        , acuerdo: []
        , subindustria: []
        , partner: []
        , grupocontrol: []
        , status: []
      }
      , options: [
        {
          code: "se"
          , name: this.$t("view.operativos.se.filters.se")
          , icon: "fas fa-sort-numeric-down"
          , type: "multinumber"
          , selected: ""
          , disabled: false
        }
        , {
          code: "seller"
          , name: this.$t("view.operativos.se.filters.seller")
          , icon: "fas fa-sort-numeric-down"
          , type: "multitext"
          , selected: ""
          , disabled: false
        }
        , {
          code: "storeid"
          , name: this.$t("view.operativos.se.filters.storeid")
          , icon: "fas fa-sort-numeric-down"
          , type: "multinumber"
          , selected: ""
          , disabled: false
        }
        , {
          code: "negocio"
          , name: this.$t("view.operativos.se.filters.negocio")
          , icon: "fas fa-check-circle"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "cuit"
          , name: this.$t("view.operativos.se.filters.cuit")
          , icon: "fas fa-id-badge"
          , type: "multinumber"
          , selected: ""
          , disabled: false
        }
        , {
          code: "provincia"
          , name: this.$t("view.operativos.se.filters.provincia")
          , icon: "fas fa-map"
          , type: "serverside"
          , selected: {}
          , disabled: false
        }
        , {
          code: "localidad"
          , name: this.$t("view.operativos.se.filters.localidad")
          , icon: "fas fa-map-marker-alt"
          , type: "serverside"
          , selected: {}
          , disabled: false
        }
        , {
          code: "acuerdo"
          , name: this.$t("view.operativos.se.filters.acuerdo")
          , icon: "fas fa-handshake"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "subindustria"
          , name: this.$t("view.operativos.se.filters.subindustria")
          , icon: "fas fa-industry"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "partner"
          , name: this.$t("view.operativos.se.filters.partner")
          , icon: "fas fa-user-tie"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "grupocontrol"
          , name: this.$t("view.operativos.se.filters.grupocontrol")
          , icon: "fas fa-sitemap"
          , type: "sino"
          , selected: false
          , disabled: false
        }
        , {
          code: "status"
          , name: this.$t("view.operativos.se.filters.status")
          , icon: "fas fa-check"
          , type: "sino"
          , selected: false
          , disabled: false
        }
      ]
    };
  }
  , created() {
    this.$nextTick(() => tippy(".btn_tippy_menu", { arrow: true, size: "large", animation: "scale", placement: "left" }));
  }
  , methods: {
    filter(filtros) {
      this.$emit("filter", filtros);
    }
    , async loading(status = false) {
      this.view.action.submit.busy = status;
    }
    , async loadSelectsData() {
      if (this.init) {
        this.loadSelectAcuerdos();
        this.loadSelectSubIndustrias();
        this.loadSelectPartners();
        if (this.select.acuerdo.filteredList.length > 0) this.init = false;
      }
    }
    , async loadSelectAcuerdos() {
      const { data: { results: { combo: acuerdoList } } } = await CombosAPI.get({ option: "acuerdo" });
      this.select.acuerdo.filteredList = acuerdoList || [];
      this.select.acuerdo.completeList = acuerdoList || [];
    }
    , async loadSelectSubIndustrias() {
      const { data: { results: { combo: subindustriaList } } } = await CombosAPI.get({ option: "subindustria" });
      this.select.subindustria.filteredList = subindustriaList || [];
      this.select.subindustria.completeList = subindustriaList || [];
    }
    , async loadSelectPartners() {
      const { data: { results: { combo: partnerList } } } = await CombosAPI.get({ option: "partner" });
      this.select.partner.filteredList = partnerList || [];
      this.select.partner.completeList = partnerList || [];
    }
    , async loadSelectProvincia(selected, value) {
      const { data: { results: { combo: provinciaList } } } = await CombosAPI.getSeverSide({ option: "ssprovincia", keyword: value });
      this.select[selected].filteredList = [...this.select[selected].filteredList, ...(provinciaList || [])];
      this.select[selected].completeList = [...this.select[selected].completeList, ...(provinciaList || [])];
    }
    , async loadSelectLocalidad(selected, value) {
      const { data: { results: { combo: localidadList } } } = await CombosAPI.getSeverSide({ option: "sslocalidad", keyword: value });
      this.select[selected].filteredList = [...this.select[selected].filteredList, ...(localidadList || [])];
      this.select[selected].completeList = [...this.select[selected].completeList, ...(localidadList || [])];
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fab-container {
  position: fixed;
  top: 110px;
  right: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/operativos/se/Filters.vue